import React, { useState, useRef } from "react";
import Input from "../Input";
import {
  getViewValue,
  getValue,
  getDecimalConfig,
  DECIMAL_SEPARATOR_BY_MARKET
} from "../../../utils/maskedFloat";
import PropTypes from "prop-types";

const getDecimalCount = (value, decimal) => {
  const pattern = decimal === "." ? /\./g : /,/g;
  const matches = value.match(pattern) || [];
  return matches.length;
};

function DecimalInput({
  market = "",
  defaultValue = "",
  mask = "0000.00",
  maxLength,
  onChange = () => {},
  min,
  max,
  ...others
}) {
  const config = useRef(getDecimalConfig(DECIMAL_SEPARATOR_BY_MARKET[market]));
  const stripRegex = config.current.stripRegex;
  const decimal = config.current.decimalMark;
  const [value, setValue] = useState(() =>
    getViewValue(defaultValue, mask, decimal)
  );

  const handleChange = e => {
    let value = e.target.value.replace(stripRegex, "");

    const hasMultipleDecimals = getDecimalCount(value, decimal) > 1;
    if (hasMultipleDecimals) {
      return;
    }

    const lastChar = value.substr(-1);
    const isDecimalMark = lastChar === decimal;

    if (!isDecimalMark) {
      // fixes issue where shown value vs dispatched values are different. In the case where one uses "." in a comma market
      value = getValue(value, mask, decimal);
      value = max && value > max && value ? max : value;
      value = min && value < min && value ? min : value;
      value = getViewValue(value, mask, decimal);
    }
    e.target.value = value;
    setValue(value);
    onChange(e, getValue(value, mask, decimal));
  };

  return (
    <Input
      {...others}
      inputMode="decimal"
      onChange={handleChange}
      value={value}
      type="text"
    />
  );
}

DecimalInput.propTypes = {
  market: PropTypes.string.isRequired
};
export default DecimalInput;
